import Vue from 'vue'
import Switches from 'vue-switches'
import ProgressSpinner from './ProgressSpinner'

Vue.component('switches', Switches)

Vue.component('language-select', () => ({
    component: import('./SelectLanguage'),
    loading: ProgressSpinner
}))
Vue.component('company-select', () => ({
    component: import('./SelectCompany'),
    loading: ProgressSpinner
}))
Vue.component('company-user-select', () => ({
    component: import('./SelectCompanyUser'),
    loading: ProgressSpinner
}))
Vue.component('client-select', () => ({
    component: import('./SelectClient'),
    loading: ProgressSpinner
}))
Vue.component('unit-select', () => ({
    component: import('./SelectUnit'),
    loading: ProgressSpinner
}))
Vue.component('process-type', () => ({
    component: import('./SelectProcessType'),
    loading: ProgressSpinner
}))
Vue.component('process-state', () => ({
    component: import('./SelectProcessState'),
    loading: ProgressSpinner
}))
Vue.component('product-select', () => ({
    component: import('./SelectProduct'),
    loading: ProgressSpinner
}))
Vue.component('dossier-no-estimate-select', () => ({
    component: import('./SelectDossierNoEstimate'),
    loading: ProgressSpinner
}))
Vue.component('password-change', () => ({
    component: import('./PasswordChange'),
    loading: ProgressSpinner
}))
Vue.component('alerts', () => ({
    component: import('./alerts'),
    loading: ProgressSpinner
}))
Vue.component('accordion-company', () => ({
    component: import('./AccordionCompany'),
    loading: ProgressSpinner
}))
Vue.component('switch-permission', () => ({
    component: import('./SwitchPermission'),
    loading: ProgressSpinner
}))
Vue.component('input-text', () => ({
    component: import('./inputText'),
    loading: ProgressSpinner
}))
Vue.component('input-text-area', () => ({
    component: import('./inputTextArea'),
    loading: ProgressSpinner
}))
Vue.component('tabs', () => ({
    component: import('./Tabs'),
    loading: ProgressSpinner
}))
Vue.component('check-box', () => ({
    component: import('./CheckBox'),
    loading: ProgressSpinner
}))
Vue.component('dialog-error', () => ({
    component: import('./DialogError'),
    loading: ProgressSpinner
}))
Vue.component('estimate-charge-type-select', () => ({
    component: import('./SelectChargeType'),
    loading: ProgressSpinner
}))
Vue.component('country-select', () => ({
    component: import('./SelectCountry'),
    loading: ProgressSpinner
}))
Vue.component('dialog-msg', () => ({
    component: import('./DialogMsg'),
    loading: ProgressSpinner
}))
Vue.component('department-select', () => ({
    component: import('./SelectDepartment'),
    loading: ProgressSpinner
}))
Vue.component('document-component', () => ({
    component: import('./Document'),
    loading: ProgressSpinner
}))
Vue.component('file-upload', () => ({
    component: import('./FileUpload'),
    loading: ProgressSpinner
}))
Vue.component('breadcrumbs-component', () => ({
    component: import('./Breadcrumbs'),
    loading: ProgressSpinner
}))
Vue.component('filter-component', () => ({
    component: import('./Filter'),
    loading: ProgressSpinner
}))
Vue.component('date-picker', () => ({
    component: import('./DatePicker'),
    loading: ProgressSpinner
}))
Vue.component('month-picker', () => ({
    component: import('./MonthPicker'),
    loading: ProgressSpinner
}))
Vue.component('supplier-select', () => ({
    component: import('./SelectSupplier'),
    loading: ProgressSpinner
}))
Vue.component('user-select', () => ({
    component: import('./SelectUser'),
    loading: ProgressSpinner
}))
Vue.component('inquiry-select', () => ({
    component: import('./SelectInquiry'),
    loading: ProgressSpinner
}))
Vue.component('inquiries-products', () => ({
    component: import('./AddInquiriesProducts'),
    loading: ProgressSpinner
}))
Vue.component('estimate-select', () => ({
    component: import('./SelectEstimate'),
    loading: ProgressSpinner
}))
Vue.component('wizard-products', () => ({
    component: import('./WizardProducts'),
    loading: ProgressSpinner
}))
Vue.component('report-download', () => ({
    component: import('./ReportDownload'),
    loading: ProgressSpinner
}))
Vue.component('location-select', () => ({
    component: import('./SelectLocation'),
    loading: ProgressSpinner
}))
Vue.component('movement-type-select', () => ({
    component: import('./SelectMovementType'),
    loading: ProgressSpinner
}))
Vue.component('warehouse-select', () => ({
    component: import('./SelectWarehouse'),
    loading: ProgressSpinner
}))
Vue.component('blood-type-select', () => ({
    component: import('./SelectBloodType'),
    loading: ProgressSpinner
}))
Vue.component('it-equipment-type-select', () => ({
    component: import('./SelectItEquipmentType'),
    loading: ProgressSpinner
}))
Vue.component('it-equipment-software-select', () => ({
    component: import('./SelectItEquipmentSoftware'),
    loading: ProgressSpinner
}))
Vue.component('it-equipment-event-type-select', () => ({
    component: import('./SelectItEquipmentEventType'),
    loading: ProgressSpinner
}))
Vue.component('it-equipment-accessory-type-select', () => ({
    component: import('./SelectItEquipmentAccessoryType'),
    loading: ProgressSpinner
}))
Vue.component('it-license-select', () => ({
    component: import('./SelectItLicense'),
    loading: ProgressSpinner
}))
Vue.component('it-user-select', () => ({
    component: import('./SelectItUser'),
    loading: ProgressSpinner
}))
Vue.component('it-equipment-select', () => ({
    component: import('./SelectItEquipment'),
    loading: ProgressSpinner
}))
Vue.component('it-event-status-select', () => ({
    component: import('./SelectItEventStatus'),
    loading: ProgressSpinner
}))
Vue.component('it-event-seriousness-select', () => ({
    component: import('./SelectItEquipmentEventSeriousness'),
    loading: ProgressSpinner
}))
Vue.component('professional-developments-entity-select', () => ({
    component: import('./SelectProfessionalDevelopmentsEntity'),
    loading: ProgressSpinner
}))
Vue.component('doctor-select', () => ({
    component: import('./SelectDoctor'),
    loading: ProgressSpinner
}))
Vue.component('months-select', () => ({
    component: import('./SelectMonths'),
    loading: ProgressSpinner
}))
Vue.component('select-vehicle-insurance-types', () => ({
    component: import('./SelectVehicleInsuranceType'),
    loading: ProgressSpinner
}))
Vue.component('vehicle-insurance-entity-select', () => ({
    component: import('./SelectVehicleInsuranceEntity'),
    loading: ProgressSpinner
}))
Vue.component('select-vehicle-license-types', () => ({
    component: import('./SelectVehicleLicenseType'),
    loading: ProgressSpinner
}))
Vue.component('expense-type-select', () => ({
    component: import('./SelectExpenseType'),
    loading: ProgressSpinner
}))
Vue.component('expense-doc-type-select', () => ({
    component: import('./SelectExpenseDocType'),
    loading: ProgressSpinner
}))
Vue.component('material-in', () => ({
    component: import('./MaterialIn'),
    loading: ProgressSpinner
}))
Vue.component('material-out', () => ({
    component: import('./MaterialOut'),
    loading: ProgressSpinner
}))
Vue.component('cost-center-select', () => ({
    component: import('./SelectCostCenter'),
    loading: ProgressSpinner
}))
Vue.component('rating-select', () => ({
    component: import('./SelectRating'),
    loading: ProgressSpinner
}))
Vue.component('batch-file-upload', () => ({
    component: import('./BatchFileUpload'),
    loading: ProgressSpinner
}))
Vue.component('currency-select', () => ({
    component: import('./SelectCurrency'),
    loading: ProgressSpinner
}))
Vue.component('dossier-location-select', () => ({
    component: import('./SelectDossierLocation'),
    loading: ProgressSpinner
}))
Vue.component('select-epi-risks', () => ({
    component: import('./SelectEpiRisks'),
    loading: ProgressSpinner
}))
Vue.component('batch-select', () => ({
    component: import('./SelectBatch'),
    loading: ProgressSpinner
}))
Vue.component('employee-select', () => ({
    component: import('./SelectEmployee'),
    loading: ProgressSpinner
}))
Vue.component('dossier-location-select', () => ({
    component: import('./SelectDossierLocation'),
    loading: ProgressSpinner
}))
Vue.component('material-loss', () => ({
    component: import('./MaterialLoss'),
    loading: ProgressSpinner
}))
Vue.component('loss-reason-select', () => ({
    component: import('./SelectLossReason'),
    loading: ProgressSpinner
}))
Vue.component('employee-category-select', () => ({
    component: import('./SelectEmployeeCategory'),
    loading: ProgressSpinner
}))
Vue.component('product-family-select', () => ({
    component: import('./SelectProductFamily'),
    loading: ProgressSpinner
}))
Vue.component('product-subfamily-select', () => ({
    component: import('./SelectProductSubfamily'),
    loading: ProgressSpinner
}))
Vue.component('iva-select', () => ({
    component: import('./SelectIva'),
    loading: ProgressSpinner
}))
Vue.component('base-warehouse-select', () => ({
    component: import('./SelectBaseWarehouse'),
    loading: ProgressSpinner
}))
Vue.component('select-verification-types', () => ({
    component: import('./SelectVerificationTypes'),
    loading: ProgressSpinner
}))
Vue.component('equipment-type-select', () => ({
    component: import('./SelectEquipmentType'),
    loading: ProgressSpinner
}))
Vue.component('verification-type-select-one', () => ({
    component: import('./SelectVerificationType'),
    loading: ProgressSpinner
}))
Vue.component('select-verification-types', () => ({
    component: import('./SelectVerificationTypes'),
    loading: ProgressSpinner
}))
Vue.component('equipment-type-select', () => ({
    component: import('./SelectEquipmentType'),
    loading: ProgressSpinner
}))
Vue.component('verification-type-select-one', () => ({
    component: import('./SelectVerificationType'),
    loading: ProgressSpinner
}))
Vue.component('product-family-select', () => ({
    component: import('./SelectProductFamily'),
    loading: ProgressSpinner
}))
Vue.component('product-subfamily-select', () => ({
    component: import('./SelectProductSubfamily'),
    loading: ProgressSpinner
}))
Vue.component('iva-select', () => ({
    component: import('./SelectIva'),
    loading: ProgressSpinner
}))
Vue.component('base-warehouse-select', () => ({
    component: import('./SelectBaseWarehouse'),
    loading: ProgressSpinner
}))
Vue.component('kinship-select', () => ({
    component: import('./SelectKinship'),
    loading: ProgressSpinner
}))
Vue.component('employee-epi-select', () => ({
    component: import('./SelectEmployeeEpi'),
    loading: ProgressSpinner
}))
Vue.component('fuel-type-select', () => ({
    component: import('./SelectFuelType'),
    loading: ProgressSpinner
}))
Vue.component('vehicle-select', () => ({
    component: import('./SelectVehicle'),
    loading: ProgressSpinner
}))
Vue.component('calendar-component', () => ({
    component: import('./Calendar'),
    loading: ProgressSpinner
}))
Vue.component('select-claim-circumstance', () => ({
    component: import('./SelectClaimCircumstance'),
    loading: ProgressSpinner
}))
Vue.component('access-level-select', () => ({
    component: import('./SelectAccessLevel'),
    loading: ProgressSpinner
}))
Vue.component('proposal-type-select', () => ({
    component: import('./SelectProposalType'),
    loading: ProgressSpinner
}))
Vue.component('radio-button', () => ({
    component: import('./RadioButton'),
    loading: ProgressSpinner
}))
Vue.component('nationality-select', () => ({
    component: import('./SelectNationality'),
    loading: ProgressSpinner
}))
Vue.component('qualifications-select', () => ({
    component: import('./SelectQualifications'),
    loading: ProgressSpinner
}))
Vue.component('work-contract-type-select', () => ({
    component: import('./SelectWorkContractType'),
    loading: ProgressSpinner
}))
Vue.component('situation-select', () => ({
    component: import('./SelectSituation'),
    loading: ProgressSpinner
}))
Vue.component('personnel-type-select', () => ({
    component: import('./SelectPersonnelType'),
    loading: ProgressSpinner
}))
Vue.component('yield-type-select', () => ({
    component: import('./SelectYieldType'),
    loading: ProgressSpinner
}))
Vue.component('select-vehicle-intervention-types', () => ({
    component: import('./SelectVehicleInterventionTypes'),
    loading: ProgressSpinner
}))
Vue.component('bank-select', () => ({
    component: import('./SelectBank'),
    loading: ProgressSpinner
}))
Vue.component('company-bank-account-select', () => ({
    component: import('./SelectCompanyBankAccount'),
    loading: ProgressSpinner
}))
Vue.component('method-select', () => ({
    component: import('./SelectMethod'),
    loading: ProgressSpinner
}))
Vue.component('component-select', () => ({
    component: import('./SelectComponent'),
    loading: ProgressSpinner
}))
Vue.component('task-type-select', () => ({
    component: import('./SelectTaskType'),
    loading: ProgressSpinner
}))
Vue.component('composite-product-select', () => ({
    component: import('./SelectCompositeProduct'),
    loading: ProgressSpinner
}))
Vue.component('production-task-select', () => ({
    component: import('./SelectProductionTask'),
    loading: ProgressSpinner
}))
Vue.component('equipment-select', () => ({
    component: import('./SelectEquipment'),
    loading: ProgressSpinner
}))
Vue.component('production-frequency-type-select', () => ({
    component: import('./SelectProductionFrequencyType'),
    loading: ProgressSpinner
}))
Vue.component('dossier-select', () => ({
    component: import('./SelectDossier'),
    loading: ProgressSpinner
}))
Vue.component('web-cam-dialog', () => ({
    component: import('./WebCamDialog'),
    loading: ProgressSpinner
}))
Vue.component('brand-select', () => ({
    component: import('./SelectBrand'),
    loading: ProgressSpinner
}))
Vue.component('district-select', () => ({
    component: import('./SelectDistrict'),
    loading: ProgressSpinner
}))
Vue.component('county-select', () => ({
    component: import('./SelectCounty'),
    loading: ProgressSpinner
}))
Vue.component('pv10-country-select', () => ({
    component: import('./SelectPv10Country'),
    loading: ProgressSpinner
}))
Vue.component('pv10-currency-select', () => ({
    component: import('./SelectPv10Currency'),
    loading: ProgressSpinner
}))
Vue.component('building-select', () => ({
    component: import('./SelectBuilding'),
    loading: ProgressSpinner
}))
Vue.component('building-room-select', () => ({
    component: import('./SelectBuildingRoom'),
    loading: ProgressSpinner
}))
Vue.component('time-picker', () => ({
    component: import('./TimePicker'),
    loading: ProgressSpinner
}))
Vue.component('team-select', () => ({
    component: import('./SelectTeam'),
    loading: ProgressSpinner
}))
Vue.component('team-no-search-select', () => ({
    component: import('./SelectTeamNoSearch'),
    loading: ProgressSpinner
}))
Vue.component('daily-service-form-template-type-select', () => ({
    component: import('./SelectDailyServiceFormTemplateType'),
    loading: ProgressSpinner
}));
Vue.component('stock-movement-type-select', () => ({
    component: import('./SelectStockMovementType'),
    loading: ProgressSpinner
}));
Vue.component('dialog-yes-no', () => ({
    component: import('./DialogYesNo'),
    loading: ProgressSpinner
}));
Vue.component('button-delete', () => ({
    component: import('./ButtonDelete'),
    loading: ProgressSpinner
}));
Vue.component('payment-condition-select', () => ({
    component: import('./SelectPaymentCondition'),
    loading: ProgressSpinner
}));
Vue.component('report-select', () => ({
    component: import('./SelectReport'),
    loading: ProgressSpinner
}));
Vue.component('email-report-select', () => ({
    component: import('./SelectReportEmail'),
    loading: ProgressSpinner
}));
Vue.component('service-form-type-select', () => ({
    component: import('./SelectServiceFormType'),
    loading: ProgressSpinner
}));
Vue.component('service-form-frequency-select', () => ({
    component: import('./SelectServiceFormFrequency'),
    loading: ProgressSpinner
}));
Vue.component('service-form-availability-select', () => ({
    component: import('./SelectServiceFormAvailability'),
    loading: ProgressSpinner
}));
Vue.component('service-form-control-select', () => ({
    component: import('./SelectServiceFormControl'),
    loading: ProgressSpinner
}));

Vue.component('sfc-checkbox', () => ({
    component: import('./SfcCheckbox'),
    loading: ProgressSpinner
}));
Vue.component('sfc-date-field', () => ({
    component: import('./SfcDateField'),
    loading: ProgressSpinner
}));
Vue.component('sfc-employee-time-clock', () => ({
    component: import('./SfcEmployeeTimeClock'),
    loading: ProgressSpinner
}));
Vue.component('sfc-integer-field', () => ({
    component: import('./SfcIntegerField'),
    loading: ProgressSpinner
}));
Vue.component('sfc-numeric-field', () => ({
    component: import('./SfcNumericField'),
    loading: ProgressSpinner
}));
Vue.component('sfc-text-area', () => ({
    component: import('./SfcTextArea'),
    loading: ProgressSpinner
}));
Vue.component('sfc-text-field', () => ({
    component: import('./SfcTextField'),
    loading: ProgressSpinner
}));
Vue.component('sfc-time-field', () => ({
    component: import('./SfcTimeField'),
    loading: ProgressSpinner
}));
Vue.component('sfc-select-location', () => ({
    component: import('./SfcSelectLocation'),
    loading: ProgressSpinner
}));
Vue.component('sfc-select-vehicle', () => ({
    component: import('./SfcSelectVehicle'),
    loading: ProgressSpinner
}));
Vue.component('sfc-select-equipment', () => ({
    component: import('./SfcSelectEquipment'),
    loading: ProgressSpinner
}));
Vue.component('sfc-select-dossier', () => ({
    component: import('./SfcSelectDossier'),
    loading: ProgressSpinner
}));
Vue.component('sfc-select-employee', () => ({
    component: import('./SfcSelectEmployee'),
    loading: ProgressSpinner
}));
Vue.component('sfc-select-custom', () => ({
    component: import('./SfcSelectCustom'),
    loading: ProgressSpinner
}));
Vue.component('sfc-file-storer', () => ({
    component: import('./SfcFileStorer'),
    loading: ProgressSpinner
}));
Vue.component('sfc-process-task-select', () => ({
    component: import('./SfcSelectProcessTask'),
    loading: ProgressSpinner
}));

Vue.component('vacation-type-select', () => ({
    component: import('./SelectVacationType'),
    loading: ProgressSpinner
}));
Vue.component('export-config-select', () => ({
    component: import('./SelectExportConfig'),
    loading: ProgressSpinner
}));
Vue.component('employee-select-table', () => ({
    component: import('./TableSelectEmployee'),
    loading: ProgressSpinner
}));
Vue.component('employee-category-select-table', () => ({
    component: import('./TableSelectEmployeeCategory'),
    loading: ProgressSpinner
}));
Vue.component('vehicle-select-table', () => ({
    component: import('./TableSelectVehicle'),
    loading: ProgressSpinner
}));
Vue.component('process-location-select', () => ({
    component: import('./SelectProcessLocation'),
    loading: ProgressSpinner
}));
Vue.component('service-order-select', () => ({
    component: import('./SelectServiceOrder'),
    loading: ProgressSpinner
}));

Vue.component('pie-chart', () => ({
    component: import('./PieChart'),
    loading: ProgressSpinner
}));

Vue.component('design-small-size-select', () => ({
    component: import('./SelectDesignSmallSize'),
    loading: ProgressSpinner
}));

Vue.component('file-storer', () => ({
    component: import('./FileStorer'),
    loading: ProgressSpinner
}));

Vue.component('task-select', () => ({
    component: import('./SelectTask'),
    loading: ProgressSpinner
}))
Vue.component('task-select-table', () => ({
    component: import('./TableSelectTask'),
    loading: ProgressSpinner
}));
Vue.component('stock-warehouse-select', () => ({
    component: import('./SelectStockWarehouse'),
    loading: ProgressSpinner
}));
Vue.component('task-template-type-select', () => ({
    component: import('./SelectTaskTemplateType'),
    loading: ProgressSpinner
}));

Vue.component('report-mailer', () => ({
    component: import('./ReportMailer'),
    loading: ProgressSpinner
}));


// WEBPACK FOOTER //
// ./resources/js/components/index.js